import style from "./Slider.module.scss";
import {
  getItemsPos,
  ScrollMenu,
  VisibilityContext,
  Props,
} from "react-horizontal-scrolling-menu";
import "./slider.scss";
import useDrag from "./useDrag";
import { createContext } from "react";
// Import Swiper styles

type ScrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

const centerOnInit = ({
  getItemById,
  scrollToItem,
  visibleItems,
}: ScrollVisibilityApiType) => {
  const { center: centerItemKey } = getItemsPos(visibleItems);
  scrollToItem(getItemById(centerItemKey), "auto", "center");
};

type SliderCoreProps = Props & {
  items: number;
  cardClassname?: string;
};

export const SliderDraggingContext = createContext<{
  dragging: boolean;
  dragStop: () => void;
}>({
  dragging: false,
  dragStop: () => {}
});

export const SliderCore = (props: SliderCoreProps) => {
  const { dragStart, dragStop, dragMove, dragging,  } = useDrag();
  const handleDrag =
    ({ scrollContainer }: ScrollVisibilityApiType) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });

  return (
    <div className={style.videos__slider} onMouseLeave={dragStop} onMouseEnter={() => {
      // debugger

        dragStop()

    }}>
      <SliderDraggingContext.Provider value={{
        dragging,
        dragStop
      }}>
        <ScrollMenu
          {...props}
          onMouseDown={() => dragStart}
          onMouseUp={() => dragStop}
          onMouseMove={handleDrag}
          onInit={centerOnInit}
        >
          {props.children}
        </ScrollMenu>
      </SliderDraggingContext.Provider>
    </div>
  );
};
